import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { TutorialPopup } from "../ui/tutorial-popup";
import { Box, IconButton } from "@mui/material";

// svg
import { ReactComponent as IconInformation } from "../../assets/svg/information.svg";
import videoPlanner from "../../assets/video/results3-x1.5.mp4";
import { luckyorangeTrackEven } from "../../services/lucky-orange/luckyorange-events";
import { TooltipControlled } from "../ui/tooltip-custom";
import { hideTutorialHint, isTutorialHintHidden } from "../../utils/tutorial-utils";

export const TutorialPopupResult = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClickOpen = () => {
    setShowPopup(true);
    luckyorangeTrackEven("Results: open hint");
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const isHintHidden = isTutorialHintHidden("hideResultHint");

  useEffect(() => {
    if (!isHintHidden) {
      setShowPopup(true);
    }
  }, []);

  const hideHint = () => {
    setShowPopup(false);
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 3000);
    // Store the flag so it doesn't show again
    hideTutorialHint("hideResultHint");
  };

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  const handleOpenTooltip = () => {
    setShowTooltip(true);
  };

  return (
    <>
      <TooltipControlled
        text="Click this button to open the hint again"
        open={showTooltip}
        handleClose={handleCloseTooltip}
        handleOpen={handleOpenTooltip}
      >
        <IconButton
          variant="outlined"
          onClick={handleClickOpen}
          sx={{ mt: "2px" }}
        >
          <IconInformation width="20px" height="20px" fill="#5D5F6A" />
        </IconButton>
      </TooltipControlled>

      {showPopup ? (
        <TutorialPopup
          title="How to explore and view each result’s performance"
          handleClose={handleClose}
          open={showPopup}
          hideHint={hideHint}
          isHintHidden={isHintHidden}
        >
          <Box sx={{ margin: "0 auto" }}>
            <video
              width="640"
              height="360"
              autoPlay
              controls
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              muted
            >
              <source src={videoPlanner} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <Box mt="24px" mb="16px">
              {/* <Typography align="left" fontSize="14px" mb="8px">
              Follow these steps as shown in the video:
              </Typography> */}
              <Box
                ml="16px"
                sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Click and drag anywhere on the map to move it around (use
                    the right mouse button for 3D). Use your mouse wheel (or
                    trackpad gestures), or click the Zoom In/Zoom Out buttons on
                    the bottom toolbar.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Using the bottom toolbar, you can easily align the map
                    north, fly back to your site, and display site dimensions.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    To select a building, simply click on it, and relevant
                    analytics will appear in the right sidebar.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </TutorialPopup>
      ) : null}
    </>
  );
};
